export class PpcDapInformationsForm {
  caisse?: string;
  assureNomComplet?: string;
  assureNir?: string;
  assureAdresse?: string;
  maladie?: boolean;
  ald?: boolean;
  maladieDetail?: string;
  traitementPrescritType: 'ppc' | 'oam';
  ppcAppareilType?:
    | 'autopilotee'
    | 'a_pression_fixe'
    | 'a_double_niveau_de_pression';
  ppcPression?: string;
  ppcInterfaceType?: string;
  ppcModeleMarque?: string;
  oamExamenRealise?: boolean;
  oamDate?: Date;
  oamType?: 'initial' | 'renouvellement';
  oamModeleMarqueEtType?: string;
  medecinConseilAccord?: boolean;
  medecinConseilConvocation?: boolean;
  medecinConseilRefusType?: 'medical' | 'administratif';
  medecinConseilDate?: Date;
  initialeComorbiditeCardioVasculaireAssocieeGraveMotif?: string;
  initialeComorbiditeRespiratoireAssocieeGraveMotif?: string;
  mois4Iah?: string;
  mois4AmeliorationSymptomatologie?: boolean;
  mois4PatientObservant?: boolean;
  mois4RefusReleveObservance?: boolean;
  annuelIah?: string;
  annuelAmeliorationSymptomatologie?: boolean;
  annuelPatientObservant?: boolean;
  annuelRefusReleveObservance?: boolean;
  oamIah?: string;
  oamAmeliorationSymptomatologie?: boolean;
  refusOuIntolerancePpc?: boolean;
  refusOuIntoleranceOam?: boolean;

  constructor(
    caisse?: string,
    assureNomComplet?: string,
    assureNir?: string,
    assureAdresse?: string,
    maladie?: boolean,
    ald?: boolean,
    maladieDetail?: string,
    traitementPrescritType: 'ppc' | 'oam' = 'ppc',
    ppcAppareilType?:
      | 'autopilotee'
      | 'a_pression_fixe'
      | 'a_double_niveau_de_pression',
    ppcPression?: string,
    ppcInterfaceType?: string,
    ppcModeleMarque?: string,
    oamExamenRealise?: boolean,
    oamDate?: Date,
    oamType?: 'initial' | 'renouvellement',
    oamModeleMarqueEtType?: string,
    medecinConseilAccord?: boolean,
    medecinConseilConvocation?: boolean,
    medecinConseilRefusType?: 'medical' | 'administratif',
    medecinConseilDate?: Date,
    initialeComorbiditeCardioVasculaireAssocieeGraveMotif?: string,
    initialeComorbiditeRespiratoireAssocieeGraveMotif?: string,
    mois4Iah?: string,
    mois4AmeliorationSymptomatologie?: boolean,
    mois4PatientObservant?: boolean,
    mois4RefusReleveObservance?: boolean,
    annuelIah?: string,
    annuelAmeliorationSymptomatologie?: boolean,
    annuelPatientObservant?: boolean,
    annuelRefusReleveObservance?: boolean,
    oamIah?: string,
    oamAmeliorationSymptomatologie?: boolean,
    refusOuIntolerancePpc?: boolean,
    refusOuIntoleranceOam?: boolean,
  ) {
    this.caisse = caisse;
    this.assureNomComplet = assureNomComplet;
    this.assureNir = assureNir;
    this.assureAdresse = assureAdresse;
    this.maladie = maladie;
    this.ald = ald;
    this.maladieDetail = maladieDetail;
    this.traitementPrescritType = traitementPrescritType;
    this.ppcAppareilType = ppcAppareilType;
    this.ppcPression = ppcPression;
    this.ppcInterfaceType = ppcInterfaceType;
    this.ppcModeleMarque = ppcModeleMarque;
    this.oamExamenRealise = oamExamenRealise;
    this.oamDate = oamDate;
    this.oamType = oamType;
    this.oamModeleMarqueEtType = oamModeleMarqueEtType;
    this.medecinConseilAccord = medecinConseilAccord;
    this.medecinConseilConvocation = medecinConseilConvocation;
    this.medecinConseilRefusType = medecinConseilRefusType;
    this.medecinConseilDate = medecinConseilDate;
    this.initialeComorbiditeCardioVasculaireAssocieeGraveMotif =
      initialeComorbiditeCardioVasculaireAssocieeGraveMotif;
    this.initialeComorbiditeRespiratoireAssocieeGraveMotif =
      initialeComorbiditeRespiratoireAssocieeGraveMotif;
    this.mois4Iah = mois4Iah;
    this.mois4AmeliorationSymptomatologie = mois4AmeliorationSymptomatologie;
    this.mois4PatientObservant = mois4PatientObservant;
    this.mois4RefusReleveObservance = mois4RefusReleveObservance;
    this.annuelIah = annuelIah;
    this.annuelAmeliorationSymptomatologie = annuelAmeliorationSymptomatologie;
    this.annuelPatientObservant = annuelPatientObservant;
    this.annuelRefusReleveObservance = annuelRefusReleveObservance;
    this.oamIah = oamIah;
    this.oamAmeliorationSymptomatologie = oamAmeliorationSymptomatologie;
    this.refusOuIntolerancePpc = refusOuIntolerancePpc;
    this.refusOuIntoleranceOam = refusOuIntoleranceOam;
  }

  toAPI(): PpcDapInformationsFormAPI {
    switch (this.traitementPrescritType) {
      case 'ppc':
        return {
          caisse: this.caisse,
          assure_nom_complet: this.assureNomComplet,
          assure_nir: this.assureNir,
          assure_adresse: this.assureAdresse,
          maladie: this.maladie,
          ald: this.ald,
          maladie_detail: this.maladieDetail,
          traitement_prescrit_type: this.traitementPrescritType,
          ppc_appareil_type: this.ppcAppareilType,
          ppc_pression: this.ppcPression,
          ppc_interface_type: this.ppcInterfaceType,
          ppc_modele_marque: this.ppcModeleMarque,
          medecin_conseil_accord: this.medecinConseilAccord,
          medecin_conseil_convocation: this.medecinConseilConvocation,
          medecin_conseil_refus_type: this.medecinConseilRefusType,
          medecin_conseil_date: this.medecinConseilDate
            ? this.medecinConseilDate.toISOString().split('T')[0]
            : undefined,
          initiale_comorbidite_cardio_vasculaire_associee_grave_motif:
            this.initialeComorbiditeCardioVasculaireAssocieeGraveMotif,
          initiale_comorbidite_respiratoire_associee_grave_motif:
            this.initialeComorbiditeRespiratoireAssocieeGraveMotif,
          '4mois_iah': this.mois4Iah,
          '4mois_amelioration_symptomatologie':
            this.mois4AmeliorationSymptomatologie,
          '4mois_refus_releve_observance': this.mois4RefusReleveObservance,
          annuel_iah: this.annuelIah,
          annuel_amelioration_symptomatologie:
            this.annuelAmeliorationSymptomatologie,
          annuel_refus_releve_observance: this.annuelRefusReleveObservance,
          refus_ou_intolerance_ppc: this.refusOuIntolerancePpc,
          refus_ou_intolerance_oam: this.refusOuIntoleranceOam,
        };
        break;

      case 'oam':
        return {
          caisse: this.caisse,
          assure_nom_complet: this.assureNomComplet,
          assure_nir: this.assureNir,
          assure_adresse: this.assureAdresse,
          maladie: this.maladie,
          ald: this.ald,
          maladie_detail: this.maladieDetail,
          traitement_prescrit_type: this.traitementPrescritType,
          oam_examen_realise: this.oamExamenRealise,
          oam_date: this.oamDate
            ? this.oamDate.toISOString().split('T')[0]
            : undefined,
          oam_type: this.oamType,
          oam_modele_marque_et_type: this.oamModeleMarqueEtType,
          medecin_conseil_accord: this.medecinConseilAccord,
          medecin_conseil_convocation: this.medecinConseilConvocation,
          medecin_conseil_refus_type: this.medecinConseilRefusType,
          medecin_conseil_date: this.medecinConseilDate
            ? this.medecinConseilDate.toISOString().split('T')[0]
            : undefined,
          initiale_comorbidite_cardio_vasculaire_associee_grave_motif:
            this.initialeComorbiditeCardioVasculaireAssocieeGraveMotif,
          initiale_comorbidite_respiratoire_associee_grave_motif:
            this.initialeComorbiditeRespiratoireAssocieeGraveMotif,
          oam_iah: this.oamIah,
          oam_amelioration_symptomatologie: this.oamAmeliorationSymptomatologie,
          refus_ou_intolerance_ppc: this.refusOuIntolerancePpc,
          refus_ou_intolerance_oam: this.refusOuIntoleranceOam,
        };
        break;
    }
  }
}

export type PpcDapInformationsFormAPI = {
  caisse?: string;
  assure_nom_complet?: string;
  assure_nir?: string;
  assure_adresse?: string;
  maladie?: boolean;
  ald?: boolean;
  maladie_detail?: string;
  traitement_prescrit_type: 'ppc' | 'oam';
  ppc_appareil_type?:
    | 'autopilotee'
    | 'a_pression_fixe'
    | 'a_double_niveau_de_pression';
  ppc_pression?: string;
  ppc_interface_type?: string;
  ppc_modele_marque?: string;
  oam_examen_realise?: boolean;
  oam_date?: string;
  oam_type?: 'initial' | 'renouvellement';
  oam_modele_marque_et_type?: string;
  medecin_conseil_accord?: boolean;
  medecin_conseil_convocation?: boolean;
  medecin_conseil_refus_type?: 'medical' | 'administratif';
  medecin_conseil_date?: string;
  initiale_comorbidite_cardio_vasculaire_associee_grave_motif?: string;
  initiale_comorbidite_respiratoire_associee_grave_motif?: string;
  '4mois_iah'?: string;
  '4mois_amelioration_symptomatologie'?: boolean;
  '4mois_refus_releve_observance'?: boolean;
  annuel_iah?: string;
  annuel_amelioration_symptomatologie?: boolean;
  annuel_refus_releve_observance?: boolean;
  oam_iah?: string;
  oam_amelioration_symptomatologie?: boolean;
  refus_ou_intolerance_ppc?: boolean;
  refus_ou_intolerance_oam?: boolean;
};
